import { FC } from 'react'
import { alpha } from '@mui/material/styles'
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import R4RIcon from 'components/R4RIcon'
import { usePersonalDataCompleteness } from 'services/profile/hooks/usePersonalDataCompleteness'

const WidgetPersonalData: FC = () => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const { shouldShowPersonalDataConfirmation, isLoading } = usePersonalDataCompleteness()

  if (!shouldShowPersonalDataConfirmation || isLoading) {
    return null
  }

  const handleClick = () => {
    navigate('/user/personal-data-confirmation-form')
  }

  if (isDesktop) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          width: '100%',
          backgroundColor: alpha(theme.r4r.yellow, 0.08),
          borderLeft: `3px solid ${theme.r4r.yellow}`,
          padding: '14px 20px 14px 23px'
        }}>
        <Box sx={{ color: theme.r4r.yellowDark, display: 'flex' }}>
          <R4RIcon name='warning' size={20} />
        </Box>
        <Typography
          sx={{ flex: 1, fontSize: '14px', fontWeight: 600, color: theme.r4r.ink }}>
          {formatMessage({
            id: 'widgetPersonalData.alertDescription',
            defaultMessage:
              'Uzupełnij swoje dane osobowe, aby korzystać ze wszystkich funkcji aplikacji.'
          })}
        </Typography>
        <Button
          onClick={handleClick}
          variant='outlined'
          sx={{
            borderColor: theme.r4r.yellow,
            color: theme.r4r.yellow,
            fontSize: '13px',
            fontWeight: 700,
            padding: '8px 16px',
            borderRadius: 0,
            whiteSpace: 'nowrap',
            '&:hover': {
              borderColor: theme.r4r.yellow,
              backgroundColor: alpha(theme.r4r.yellow, 0.08)
            }
          }}>
          {formatMessage({
            id: 'widgetPersonalData.button',
            defaultMessage: 'Uzupełnij'
          })}
        </Button>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        width: '100%',
        backgroundColor: alpha(theme.r4r.yellow, 0.08),
        borderLeft: `3px solid ${theme.r4r.yellow}`,
        padding: '12px 16px 12px 19px'
      }}>
      <Box sx={{ color: theme.r4r.yellowDark, display: 'flex' }}>
        <R4RIcon name='warning' size={20} />
      </Box>
      <Typography sx={{ flex: 1, fontSize: '13px', fontWeight: 700, color: theme.r4r.ink }}>
        {formatMessage({
          id: 'widgetPersonalData.title',
          defaultMessage: 'Uzupełnij dane osobowe'
        })}
      </Typography>
      <Button
        onClick={handleClick}
        variant='outlined'
        sx={{
          borderColor: theme.r4r.yellow,
          color: theme.r4r.yellowDark,
          fontSize: '13px',
          fontWeight: 500,
          padding: '4px 11px',
          borderRadius: 0,
          whiteSpace: 'nowrap',
          '&:hover': { borderColor: theme.r4r.yellow }
        }}>
        {formatMessage({
          id: 'widgetPersonalData.button',
          defaultMessage: 'Uzupełnij'
        })}
      </Button>
    </Box>
  )
}

export default WidgetPersonalData
